import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from './locales/en/translation.json';
import es from './locales/es/translation.json';

const fallbackLng = 'en';
const searchParams = new URLSearchParams(window.location.search);
const localeParam = searchParams.get('x-locale-lng');

const isNonProductionEnv = ['local', 'dev', 'qa', 'stg'].some((env) =>
  window.location.origin.includes(env),
);

const lng = isNonProductionEnv && localeParam ? localeParam : fallbackLng;

i18n.use(initReactI18next).init({
  debug: false,
  fallbackLng,
  interpolation: {
    escapeValue: false,
  },
  lng,
  resources: {
    en,
    es,
  },
  returnObjects: true,
});
